(function(){

    var mediaEventType = {
        MediaStarted: 4,
        MediaAbandoned: 5,
        MediaViewed: 8,
        MediaFirstLaunch: 63,
    };

    if (!gv.mediaItemName) {
        gv.mediaItemName = 'BC_pacesetter';
    }
    var featureID = 324;
    var preventSeeking = true;
    var hasCompleted = false;
    var hasNotSeenSuccessModal = true;
    var recordattempt = 0;
    var modalBG = $('#js-section--modal');
    var modalFail = $('#js-section--modal-fail');



    var tryAgainMaybe = function() {
        if (recordattempt < 3) {
            recordattempt++;
            recordMediaViewed();
        } else {
            showProblemModal();
        }
    };

    var recordMediaViewed = function(){
        $.ajax({ url: "/ExternalServices/VersionedApi/v1/Pacesetter/RecordMediaViewed/",
                       contentType: "application/json; charset=utf-8",
                       dataType: "JSON",
                       type: "GET",
                       data: {"videoName": gv.mediaItemName, "application": "web", "feature": featureID }
                })
                .done( function (data){
                    if (data) {
                        showCompletedModal();
                    } else {
                        tryAgainMaybe();
                    }
                })
                .fail( function () {
                    tryAgainMaybe();
                });
    };

    var recordMediaEvent = function(eventType){
        $.ajax({ url: "/ExternalServices/VersionedApi/v1/Pacesetter/RecordMediaEvent/",
               contentType: "application/json; charset=utf-8",
               dataType: "JSON",
               type: "GET",
               data: { "videoName": gv.mediaItemName, "eventType": eventType, "application": "web", "feature": featureID },
        });
    };

    var removeTitle = function(b){
        if (b) {
            $('#js-title').remove();
        }
    };

    var displayModal = function(modalType) {
        modalType.remove();
        var modal = modalType.find('.modal');
        modalType.css({'display':'block','visibility':'hidden'});
        $('body').css({'position':'relative'}).append(modalType);
        var modalHeight = modal.height();
        var modalTopPosition = (window.innerHeight - modalHeight)/2 + $(window).scrollTop();
        modal.css('top',modalTopPosition + 'px');
        modalType.css({'visibility':'visible'});
        modalType.find('.js-close').on('click', removeModal);
    };

    var removeModal = function(event) {
        $(event.target).closest('.js-modal').remove();
    };

    function showCompletedModal () {
        if (hasNotSeenSuccessModal && gv.isEligible) {
            hasNotSeenSuccessModal = false;
            displayModal(modalBG);
            recordMediaEvent(mediaEventType.MediaFirstLaunch);
        }
    }

    function showProblemModal () {
        displayModal(modalFail);
    }


    if (gv.pacesetterVideosWatched.length > 0) {
        hasCompleted = gv.pacesetterVideosWatched.some(function(obj){
            return obj.ViewedTime;
        });
        hasNotSeenSuccessModal = false;
        preventSeeking = hasCompleted ? false : true;
    }

    if (/aat=1/.test(location.search.substring(1))) {
        preventSeeking = false;
    }

    var melaPlayer = new MelaVideoPlayer('mediaContainer','mediaplayer',360,640, gv.mediaItemName);

    var videoSetup = {
        // Media
        Video : gv.pacesetterVideo,
        // Player Properties
        PreventSeeking : preventSeeking, // Defaults to False
        // ShowCustomProgressBar : true, // Defaults to False
        Autostart : false, // Defaults to False
        ScrollToTop: true, // Defaults to False
        RecordingInterval: 2, // Minimum of 2 seconds, Defaults to 10 seconds if nothing is passed. A -1 means that recording should not occur
        CanResumePlay: true, // Defaults to False
        FeatureID: featureID, // If one is not passed we just set it to 0 (Undefined) as the table requires a feature.
        //Events
        OnReadyFunction : function() {
            //alert("OnReadyFunction");
        },
        OnFirstLaunchFunction : function() {
            //alert("OnFirstLaunchFunction");
        },
        OnFirstResumeFunction: function () { // Because of the way FirstResume is implemented, there is not and "event" parameter like the others.
            //alert("OnFirstResumeFunction");
        },
        OnPlayFunction : function() {
            recordMediaEvent(mediaEventType.MediaStarted);
        },
        OnPauseFunction : function() {
            //alert("OnPauseFunction");
        },
        OnCompleteFunction : function() {
            recordMediaViewed();
            hasCompleted = true;
        },
        OnPlayProgressFunction : function() {
            //alert("OnPlayProgressFunction");
        }
    };


    // Events
    melaPlayer.SetupVideo(videoSetup);
    removeTitle(hasCompleted);

}());
